module.exports = require("./se-FI.d.ts");